import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import { ENROLL_PLATFORM } from '@/store/actions/platforms';
import WTextInput from "@/components/wrapper/w-text-input.vue";
import { CLUSTER_DOMAIN } from '@/store/actions/api';
var AddPlatform = /*#__PURE__*/function (_Vue) {
  function AddPlatform() {
    var _this;
    _classCallCheck(this, AddPlatform);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddPlatform, [].concat(args));
    _defineProperty(_this, "toggleConnectPlatformDialog", void 0);
    _defineProperty(_this, "url", '');
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "isLoading", false);
    _defineProperty(_this, "visible", false);
    return _this;
  }
  _inherits(AddPlatform, _Vue);
  return _createClass(AddPlatform, [{
    key: "updateUrl",
    value: function updateUrl(value) {
      this.url = value;
    }
  }, {
    key: "addPlatform",
    value: function addPlatform() {
      var _this$url,
        _this2 = this;
      this.errorMsg = '';
      this.isLoading = true;
      this.url = (_this$url = this.url) === null || _this$url === void 0 ? void 0 : _this$url.trim();
      if (this.url) {
        if (!this.url.startsWith('https://') && !this.url.startsWith('http://')) {
          this.url = 'https://' + this.url;
        }
        store.dispatch(ENROLL_PLATFORM, this.url).then(function () {
          // it will be redirect if ok
        }).catch(function (err) {
          _this2.isLoading = false;
          _this2.errorMsg = err;
        });
      }
    }
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.errorMsg = '';
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], AddPlatform.prototype, "toggleConnectPlatformDialog", void 0);
AddPlatform = __decorate([Options({
  components: {
    WTextInput: WTextInput
  },
  data: function data() {
    return {
      CLUSTER_DOMAIN: CLUSTER_DOMAIN
    };
  },
  watch: {
    toggleConnectPlatformDialog: function toggleConnectPlatformDialog() {
      this.visible = this.toggleConnectPlatformDialog;
    }
  }
})], AddPlatform);
export default AddPlatform;